import React from "react";
import "./NavBar.scss";
import phylloLogoDark from "../../../assets/images/phylloLogoDark.svg";
import phylloLogoLight from "../../../assets/images/phylloLogoLight.svg";
function NavBar({ isLoggedIn, isLightMode, history }) {
  return (
    <nav className={`navbar ${isLightMode ? "bg-light" : "bg-dark"}`}>
      <div className="container-fluid">
        <a
          className={
            isLoggedIn ? "navbar-brand" : "navbar-brand brand-full-width"
          }
          href="/dashboard"
        >
          {isLightMode ? (
            <img src={phylloLogoDark} />
          ) : (
            <img src={phylloLogoLight} />
          )}
        </a>
        <div className="d-flex">
          <a
            className={`nav-link nav-text ${
              isLightMode ? "nav-link-light" : "nav-link-dark"
            }`}
            aria-current="page"
            href={process.env.REACT_APP_PRIVACY_POLICY_URL}
            target="_blank"
          >
            Privacy Policy
          </a>
          <a
            className={`nav-link nav-text ${
              isLightMode ? "nav-link-light" : "nav-link-dark"
            }`}
            href={process.env.REACT_APP_USER_AGREEMENT}
            target="_blank"
          >
            Terms
          </a>
          {isLoggedIn && (
            <a
              className={`nav-link ${
                isLightMode
                  ? "nav-link-light logout-btn-light"
                  : "nav-link-dark logout-btn-dark"
              }`}
              href="#"
              onClick={() => {
                window.sessionStorage.clear();
                history.push("/");
              }}
            >
              Logout
            </a>
          )}
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
